import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const TaxStructuringOptimization = () => {
  const serviceData = {
    title: "Tax Structuring & Optimization",
    heading: "Tax Structuring & Optimization",
    image: subTopicImages["Tax Structuring & Optimization"],
    intro: "Designing tax-efficient business structures — the right way",
    description: [
      "Every major business decision — entering India, restructuring, raising capital, acquiring a business, setting up a new vertical or exiting — has a tax impact.",
      "Tax structuring is the process of designing your business, funding, ownership and operations so that taxes remain legally efficient, compliance remains strong, documentation remains robust and long-term risks are minimised.",
      "Our philosophy is simple: tax planning should be compliant, transparent and sustainable. We do not believe in aggressive or risky structures. We design solutions that stand the test of time — commercially, legally and operationally.",
    ],
    services: [
      {
        title: "Business & Entity Structuring",
        text: "We advise on selecting the right India structure, including:",
        list: [
          "subsidiary",
          "branch office",
          "liaison office",
          "LLP",
          "joint venture",
          "holding company framework",
        ],
        extraInfo:
          "Our recommendations are based on commercial model, taxation, FEMA rules, group control, capital flows and exit planning.",
      },
      {
        title: "Capital & Funding Structuring",
        text: "We help evaluate the most appropriate funding routes, including:",
        list: [
          "equity",
          "compulsorily convertible debentures (CCDs)",
          "debt",
          "hybrid instruments",
        ],
        extraInfo:
          "Covering pricing norms, FEMA conditions, withholding tax and repatriation flexibility — ensuring compliance without constraining growth.",
      },
      {
        title: "Reorganisation & Restructuring Tax Planning",
        text: "We provide tax planning support for:",
        list: [
          "mergers",
          "hive-offs",
          "business sales",
          "asset transfers",
          "internal group restructuring",
        ],
        extraInfo:
          "Evaluating tax neutrality options, stamp duty aspects, capital gains exposure and continuity conditions to keep restructurings clean and compliant.",
      },
      {
        title: "Profit Repatriation & Exit Planning",
        text: "We assist in designing efficient mechanisms for:",
        list: [
          "dividend payout models",
          "royalty and fee structures",
          "buy-back strategies",
          "capital reduction",
          "exit taxation models",
        ],
        extraInfo:
          "Ensuring funds move across borders smoothly, efficiently and legally.",
      },
      {
        title: "Transfer Pricing Alignment",
        text: "We ensure tax structuring is aligned with group transfer pricing by focusing on:",
        list: [
          "consistent pricing logic",
          "defensible documentation",
          "strong commercial rationale",
        ],
        extraInfo:
          "So that tax positions remain robust during audits and regulatory scrutiny.",
      },
    ],
    benefitsIntro: "How this service strengthens your tax position:",
    benefits: [
      "Legally efficient and sustainable tax structures",
      "Strong compliance and documentation discipline",
      "Reduced long-term tax and litigation risk",
      "Alignment with FEMA and regulatory requirements",
      "Commercially practical and defensible structures",
    ],
    research:
      "Our structuring advice balances tax efficiency with regulatory integrity — helping businesses grow with confidence while remaining fully compliant.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default TaxStructuringOptimization;
